import { gridBreakpoints } from '../../theme';
export const ANALYTICS_EVENT_SOURCE_APP_HEADER = 'appHeader';
export const ANALYTICS_SUBJECT_ID_RATINGS = 'ratings';

/**
 * AppHeader breakpoint for displaying the mobile version, used as:-
 * - with min width: `@media (min-width: ${APP_HEADER_MOBILE_BREAKPOINT}px) { ... }`
 * - with max width: `@media (max-width: ${APP_HEADER_MOBILE_BREAKPOINT-1}px) { ... }`
 **/
export const APP_HEADER_MOBILE_BREAKPOINT = gridBreakpoints.sm;